<template>
	<div class="content__footer">
		<ul class="service-menu">
			<li class="service-menu__item">
				<a class="service-menu__link" href="#">На главный сайт</a>
			</li>

			<li class="service-menu__item">
				<a class="service-menu__link" href="#">Регистрация</a>
			</li>

			<li class="service-menu__item">
				<a class="service-menu__link" href="#">Документы</a>
			</li>

			<li class="service-menu__item">
				<a class="service-menu__link" href="#">Правила</a>
			</li>

			<li class="service-menu__item">
				<a class="service-menu__link" href="#">О компании</a>
			</li>
		</ul>
		<ul class="socials">
			<li class="socials__item">
				<a class="socials__link" href="#">
					<img src="../assets/icons/icon-vkontakte.jpg" alt>
				</a>
			</li>

			<li class="socials__item">
				<a class="socials__link" href="#">
					<img src="../assets/icons/icon-youtube.jpg" alt>
				</a>
			</li>

			<li class="socials__item">
				<a class="socials__link" href="#">
					<img src="../assets/icons/icon-instagram.jpg" alt>
				</a>
			</li>

			<li class="socials__item">
				<a class="socials__link" href="#">
					<img src="../assets/icons/icon-facebook.jpg" alt>
				</a>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		name: "ContentFooter"
	}
</script>
